import DropDown from './components/Shared/DropDown.vue';
import Modal from './components/Shared/Modal/Modal.vue';
import Pagination from './components/Shared/Pagination/Pagination.vue';
import ChangePasswordModal from './modals/ChangePasswordModal.vue';
import TopNavBar from './components/Layout/TopNavbar.vue';
import Loader from './components/Shared/Loader.vue';
import ChooseUserModal from "./modals/ChooseUserModal.vue";
import BottomBar from "./components/Layout/BottomBar.vue";
import MyTrainingsModal from "./modals/MyTrainingsModal.vue";
import SeeTrainingsModal from "./modals/SeeTrainingsModal.vue";
import ShowImageModal from "./modals/ShowImageModal.vue";
import ChooseDateForMemberShip from "./modals/ChooseDateForMemberShip.vue";
import ChooseImeiAfterPicture from "./modals/ChooseImeiAfterPicture.vue";
import CropImageModal from "./modals/CropImageModal.vue";
import SeeCategoryColors from "./modals/SeeCategoryColors.vue";
import ShowMore from "./components/Shared/ShowMore.vue";
import DeleteWaitingListModal from "./modals/DeleteWaitingListModal.vue";
import ShowQrCodeDialog from "./modals/ShowQrCodeDialog.vue";
import AddTrainingOfTheDay from "./modals/AddTrainingOfTheDay.vue";
import ModalNotClickable from "./components/Shared/Modal/ModalNotClickable.vue";
import ChooseTrainingDefinition from "./modals/ChooseTrainingDefinition.vue";
import AddTrainingDefinitionWod from "./modals/AddTrainingDefinitionWod.vue";
import AddTrainingDefinitionPersonal from "./modals/AddTrainingDefinitionPersonal.vue";
import AddTrainingOfTheDayPersonal from "./modals/AddTrainingOfTheDayPersonal.vue";
import PlayVideoDialog from "./modals/PlayVideoDialog.vue";
import MyLoader from "./components/Layout/MyLoader.vue";
import AddUserCredit from "./modals/AddUserCredit.vue";
import CustomCalendar from "./components/Shared/CustomCalendar.vue";
import CopyTrainingOfTheDayForDatesModal from "./modals/CopyTrainingOfTheDayForDatesModal.vue";
import SellBuyArticle from "./modals/SellBuyArticle.vue";
import CloseSchedule from "./modals/CloseSchedule.vue";
import EditSchedule from "./modals/EditSchedule.vue";
import AddScheduleAdditionalCost from "./modals/AddScheduleAdditionalCost.vue";
import ChangeProfitArticle from "./modals/ChangeProfitArticle.vue";
import ChangeScheduleItem from "./modals/ChangeScheduleItem.vue";
import ChooseShopItemModal from "./modals/ChooseShopItemModal.vue";
import CashRegisterWidget from "./widgets/CashRegisterWidget.vue";


/**
 * Register global components here and use them as a plugin in your main Vue instance
 */

const SharedComponents = {
    install (Vue) {
        Vue.component('loader', Loader);
        Vue.component('drop-down', DropDown);
        Vue.component('custom-calendar', CustomCalendar);
        Vue.component('modal', Modal);
        Vue.component('modal-non-clickable', ModalNotClickable);
        Vue.component('change-password-modal', ChangePasswordModal);
        Vue.component('pagination', Pagination);
        Vue.component('show-more', ShowMore);
        Vue.component('topnavbar', TopNavBar);
        Vue.component('choose-user-modal', ChooseUserModal);
        Vue.component('choose-shop-item-modal', ChooseShopItemModal);
        Vue.component('choose-training-definition-modal', ChooseTrainingDefinition);
        Vue.component('delete-waiting-list', DeleteWaitingListModal);
        Vue.component('close-schedule', CloseSchedule);
        Vue.component('change-profit-article', ChangeProfitArticle);
        Vue.component('change-schedule-item', ChangeScheduleItem);
        Vue.component('edit-schedule', EditSchedule);
        Vue.component('additional-cost-schedule', AddScheduleAdditionalCost);
        Vue.component('choose-date-for-membership-modal', ChooseDateForMemberShip);
        Vue.component('choose-imei-after-picture', ChooseImeiAfterPicture);
        Vue.component('crop-image-modal', CropImageModal);
        Vue.component('my-trainings', MyTrainingsModal);
        Vue.component('see-trainings', SeeTrainingsModal);
        Vue.component('add-user-credit', AddUserCredit);
        Vue.component('sell-buy-article', SellBuyArticle);
        Vue.component('add-training-of-the-day-wod', AddTrainingOfTheDay);
        Vue.component('add-training-of-the-day-personal', AddTrainingOfTheDayPersonal);
        Vue.component('add-training-definition-wod', AddTrainingDefinitionWod);
        Vue.component('add-training-definition-personal', AddTrainingDefinitionPersonal);
        Vue.component('show-image-dialog', ShowImageModal);
        Vue.component('play-video-dialog', PlayVideoDialog);
        Vue.component('my-bottom-bar', BottomBar);
        Vue.component('my-loader', MyLoader);
        Vue.component('see-category-color', SeeCategoryColors);
        Vue.component('show-qr-code-dialog', ShowQrCodeDialog);
        Vue.component('cash-register-widget', CashRegisterWidget);
        Vue.component('copy-training-for-dates', CopyTrainingOfTheDayForDatesModal);
    }
}

export default SharedComponents



// WEBPACK FOOTER //
// ./src/sharedComponents.js